import React from "react";

import Button, { ButtonProps } from "@material-ui/core/Button";

type ButtonClickHandler = {
  bivarianceHack(event: { preventDefault: () => void }): void;
}['bivarianceHack'];

export interface CustomButtonProps extends Omit<ButtonProps, 'onClick'> {
  IsRowButton?: boolean;
  onClick?: ButtonClickHandler;
};

export default function RegularButton(props: CustomButtonProps) {
  //const classes = useStyles();
  const {
    fullWidth,
    IsRowButton,
    variant,
    children,
    onClick,
    ...rest
  } = props;

  const handleClick = onClick
    ? (event: React.MouseEvent<HTMLButtonElement>) => {
      onClick(event);
    }
    : undefined;

  return (
    <div style={{ paddingTop: IsRowButton ? 20 : 0 }}>

      <Button
        fullWidth={fullWidth || IsRowButton || false}
        variant={variant ?? "contained"}
        onClick={handleClick}
        {...rest}>
        {children}
      </Button>
    </div>
  );
}
